import { DSPaginatedList } from 'shared-definitions/types'
import { ApiPostsProps } from 'data-source/types.wp'

export function paginationMapper(
  input: ApiPostsProps<unknown>
): Pick<DSPaginatedList<any>, 'perPage' | 'currentPage' | 'totalItems' | 'resource'> {
  return {
    resource: 'paginated-list',
    perPage: input.posts_per_page,
    currentPage: input.current_page,
    totalItems: input.total_posts,
  }
}
